import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';
import RankingSection from '@/pages/home/components/RankingSection';
import IndexSection from '@/pages/home/components/IndexSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AppSection from '@/pages/home/components/AppSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FAQSection from '@/pages/home/components/FAQSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AboutSection />
        <RankingSection />
        <IndexSection />
        <MediaSection />
        <TopicsSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <CommentsSection />
        <FAQSection />
        <FeaturesSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}